import type { IconProps } from './icons/props.ts'

/**
 * Render the Alex triangle mark.
 * @param props.size - square size in px (default 24).
 * @param props.className - extra class for layout placement.
 * @returns the decorative Alex mark.
 */
export function AlexMark({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path d="M12 2.75 22 21.25H2L12 2.75Z" fill="currentColor" />
    </svg>
  )
}
